import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined'
// import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined"

const SystemSettingMenu = {
    id: 'SystemSettingRoot',
    title: 'System Setting',
    type: 'group',
    children: [
        // {
        //     id: 'systemSettingScheduleSort',
        //     title: 'Schedule Sort',
        //     type: 'item',
        //     url: '/systemSetting/scheduleSort',
        //     icon: SettingsSuggestOutlinedIcon
        // },
        {
            id: 'systemSettingCreditType',
            title: 'Account Type',
            type: 'item',
            url: '/systemSetting/creditType',
            icon: SettingsSuggestOutlinedIcon
        },
        {
            id: 'systemSettingReceiptType',
            title: 'Receipt Type',
            type: 'item',
            url: '/systemSetting/receiptType',
            icon: SettingsSuggestOutlinedIcon
        },
        // {
        //     id: 'treatmentConsumables',
        //     title: 'Treatment Usage Setting',
        //     type: 'item',
        //     url: '/treatments/settings',
        //     icon: SettingsSuggestOutlinedIcon
        // },
        // {
        //     id: 'systemSettingPagePermission',
        //     title: 'Page Permission',
        //     type: 'item',
        //     url: '/systemSetting/pagePermitTable',
        //     icon: SettingsSuggestOutlinedIcon
        // },
        // {
        //     id: 'moduleNavAclTable',
        //     title: 'Module Permission',
        //     type: 'item',
        //     url: '/systemSetting/moduleNavAclTable',
        //     icon: SettingsSuggestOutlinedIcon
        // },
        // {
        //     id: 'userWageTable',
        //     title: 'Staff Wage Setting',
        //     type: 'item',
        //     url: '/systemSetting/userWageTable',
        //     icon: SettingsSuggestOutlinedIcon
        // },
        {
            id: 'paymentMethodSetting',
            title: 'Payment Method Setting',
            type: 'item',
            url: '/systemSetting/paymentMethodSetting',
            icon: SettingsSuggestOutlinedIcon
        },
        {
            id: 'clinicRuntimeSetting',
            title: 'Clinic Runtime',
            type: 'item',
            url: '/systemSetting/clinicRuntime',
            icon: SettingsSuggestOutlinedIcon
        },
        // {
        //     id: 'customisedSetting',
        //     title: 'Customised Setting',
        //     type: 'item',
        //     url: '/systemSetting/customisedSetting',
        //     icon: SettingsSuggestOutlinedIcon
        // },
        {
            id: 'initialSettingRoot',
            title: 'Opening Setup',
            type: 'collapse',
            icon: SettingsSuggestOutlinedIcon,
            children: [
                
                // {
                //     id: 'initialInventory',
                //     title: 'Opening Inventory',
                //     type: 'item',
                //     url: '/inventory/initial',
                //     breadcrumbs: false,
                //     icon: ShoppingCartOutlinedIcon
                // },
                {
                    id: 'initialFamilyCredit',
                    title: 'Opening Family Credit',
                    type: 'item',
                    url: '/credit/initial',
                    breadcrumbs: false,
                    icon: SettingsSuggestOutlinedIcon
                },
                {
                    id: 'initialTreatmentBalance',
                    title: 'Opening Treatment Balance',
                    type: 'item',
                    url: '/credit/initialTreatmentBalance',
                    breadcrumbs: false,
                    icon: SettingsSuggestOutlinedIcon
                }
            ]
        }
            
    ]
}
export default SystemSettingMenu
